import {Injectable, NgZone} from "@angular/core";
import {CommonService} from "./common.service";
import OneSignal from "onesignal-cordova-plugin";
import {environment} from "../../../environments/environment";
import {NavigationService} from "./navigation.service";
import {UserService} from "./user.service";

@Injectable({
  providedIn: 'root'
})
export class OnesignalService {

  constructor(private commonService: CommonService,
              private navigationService: NavigationService,
              private userService: UserService,
              private zone: NgZone) {

  }

  initOneSignal(userId?: string) {

    if (this.commonService.isMobile()) {

      this.requestNotificationPermission().then();

      // Remove this method to stop OneSignal Debugging
      OneSignal.Debug.setLogLevel(6)

      // Replace YOUR_ONESIGNAL_APP_ID with your OneSignal App ID
      OneSignal.initialize(environment.oneSignalAppId);

      OneSignal.Notifications.addEventListener('click', async (e) => {

        let clickData = await e.notification;
        // L'URL di lancio è in event.notification.launchURL o event.notification.data.url (dipende come invii la notifica)
        const launchUrl = clickData.launchURL || clickData.additionalData['url'] || '';

        const relativePath = launchUrl.startsWith(environment.appDeepLink)
          ? launchUrl.replace(environment.appDeepLink, '')
          : launchUrl;

        this.zone.run(() => {
          //this.navigationService.fromDeeplinkUrl = relativePath;
          this.navigationService.goRoot([relativePath]);
        });

      });

      OneSignal.User.addTag('device_uuid', this.userService.uuid);
      OneSignal.User.addTag('profile_type', this.commonService.profileType);

      if (userId) {
        OneSignal.User.addTag('user_id', userId);      }

    }

  }

  async requestNotificationPermission() {
    OneSignal.Notifications.requestPermission(true).then();
  }
}
